module.exports = __webpack_public_path__ + "img/hd1.1dea99fd.png";